<div class="app-layout">
    <div class="app-layout__outer-container">
        <ng-content select="[app-layout-above-inner-container]"></ng-content>
        <div class="app-layout__inner-container">
            <ng-content></ng-content>
        </div>
    </div>
</div>